export const URL_PATTERN =
  /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .+-]*)*\/?$/i;

export const isValidUrl = (url: string): boolean => {
  if (!url || url.trim() === "") {
    return false;
  }

  return URL_PATTERN.test(url.trim());
};
